import React from "react";
import { Link } from "react-router-dom";
import { BackgroundBeams } from "../ui/background-beams.tsx";

export default function PaymentDeclined() {
  return (
    <div className="relative w-full min-h-screen bg-black text-white flex flex-col items-center justify-center px-4 py-12">
      <BackgroundBeams />

      {/* Inline styles for the SVG X animation */}
      <style>{`
        @keyframes draw-circle {
          from { stroke-dashoffset: 300; }
          to   { stroke-dashoffset: 0; }
        }
        @keyframes draw-x {
          from { stroke-dashoffset: 120; }
          to   { stroke-dashoffset: 0; }
        }

        .animate-draw-circle {
          stroke-dasharray: 300;
          stroke-dashoffset: 300;
          animation: draw-circle 0.8s ease-out forwards;
        }
        .animate-draw-x {
          stroke-dasharray: 120;
          stroke-dashoffset: 120;
          animation: draw-x 0.6s ease-out forwards;
        }

        @media (prefers-reduced-motion: reduce) {
          .animate-draw-circle,
          .animate-draw-x {
            animation: none;
            stroke-dashoffset: 0;
          }
        }
      `}</style>

      {/* Declined Box / Card */}
      <div className="relative z-10 max-w-md w-full bg-gray-900/90 border border-gray-700 rounded-xl shadow-lg p-8 text-center backdrop-blur">
        {/* Animated SVG X */}
        <svg viewBox="0 0 100 100" className="mx-auto h-20 w-20">
          {/* Circle outline */}
          <circle
            cx="50"
            cy="50"
            r="45"
            fill="none"
            stroke="#ef4444" /* Tailwind red-500 */
            strokeWidth="4"
            className="animate-draw-circle"
          />
          {/* First line of the X */}
          <line
            x1="35"
            y1="35"
            x2="65"
            y2="65"
            stroke="#ef4444"
            strokeWidth="6"
            strokeLinecap="round"
            className="animate-draw-x"
          />
          {/* Second line of the X */}
          <line
            x1="65"
            y1="35"
            x2="35"
            y2="65"
            stroke="#ef4444"
            strokeWidth="6"
            strokeLinecap="round"
            className="animate-draw-x"
          />
        </svg>

        <h1 className="mt-6 text-3xl font-bold text-red-500">Payment Declined</h1>
        <p className="mt-4 text-lg text-gray-300">
          Unfortunately, your payment could not be processed. Please try again or use a different payment method.
        </p>

        {/* Single blue button */}
        <div className="mt-8">
          <Link to="/datanomad">
            <button className="w-full bg-blue-500 hover:bg-blue-600 text-white font-semibold px-6 py-3 rounded-lg">
              Back to Home
            </button>
          </Link>
        </div>
      </div>
    </div>
  );
}
